var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLinkedinGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.40001 24H0.299995V7.95H5.40001V24ZM2.85 5.7C1.2 5.7 0 4.5 0 2.85C0 1.2 1.35 0 2.85 0C4.5 0 5.7 1.2 5.7 2.85C5.7 4.5 4.5 5.7 2.85 5.7ZM24 24H18.9V15.3C18.9 12.75 17.85 12 16.35 12C14.85 12 13.35 13.2 13.35 15.45V24H8.25V7.95H13.05V10.2C13.5 9.15 15.3 7.5 17.85 7.5C20.7 7.5 23.7 9.15 23.7 14.1V24H24Z",
    fill: "#0F973D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLinkedinGreen);
export default __webpack_public_path__ + "static/media/ic_linkedin_green.61b8f3a118f6db883d4005a74cfcf9a1.svg";
export { ForwardRef as ReactComponent };